<!--券、院提醒列表-->
<template>
    <div>
        <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
            <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                <div class="name-txt">{{ checkedRegion.name }}</div>
                <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
            </div>
            <div v-if="checkedStore.id != -1" @click="openRegionStorePopup" class="store-name-box flex-row flex-between flex-y-center">
                <div class="name-txt">{{ checkedStore.name }}</div>
                <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
            </div>
        </div>
        <div class="date-box flex-between flex-y-center mb-10">
            <div class="font26 Greys flex-y-center">{{ dateTime }}到期：<span class="font40 Blacks bold">{{ total }}</span><span class="font28 Blacks">人</span></div>
            <div class="select-box flex flex-y-center flex-start">
                <div class="select-item flex-between flex-y-center" @click="selectTypePopup">
                    <div class="select-tit">{{ checkedType && checkedType.name }}</div>
                    <van-icon name="play" class="select-arrow" />
                </div>
            </div>
        </div>
        <form action="/">
            <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机" left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
            </van-search>
        </form>
        <div class="select-box flex flex-y-center flex-start">
            <div class="select-item mr-50 flex-between flex-y-center" @click="selectEmployeePopup">
                <div class="select-tit">{{ checkedEmployee && checkedEmployee.name }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
        </div>
        <div class="list-box">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                <!-- 下拉刷新 -->
                <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="onLoad" :offset="20" :immediate-check="false">
                    <div class="customer-list" v-for="(item, index) in expireList" :key="index" @click="toDetail(item.custId, item.custMobile)">
                        <div class="top-box">
                            <div class="flex-row">
                                <img class="customerHeadPortrait" referrerpolicy="no-referrer" :src="item.avatar" alt="" />
                                <div class="customer-info flex-1">
                                    <div class="flex-1 flex-y-center flex-start">
                                        <div class="customer-name">{{ item.custName }}</div>
                                        <img class="card-icon" referrerpolicy="no-referrer" v-if="item.cardLevelImg" :src="item.cardLevelImg" alt="" />
                                        <div class="customer-name flex-1 flex-y-center"> <img class="arrow_right" referrerpolicy="no-referrer" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" />
                                        </div>
                                        <!-- <img class="icon-item chat-icon" referrerpolicy="no-referrer" @click.stop="toOpenWechat(item)" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/chat-icon.png" /> -->
                                        <img class="icon-item" referrerpolicy="no-referrer" @click.stop="toContact(item.custMobile)" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/phone-icon.png" />
                                    </div>
                                    <div class="churn-time" v-if="postId == 1 || postId == '1472787652026765367'">
                                        {{ dimension == 1 ? '顾问' : '主诊' }}：{{ item.empName }}
                                    </div>
                                    <div class="churn-time store-time">上次{{ dimension == 1 ? '到店' : '到诊' }}：{{ item.lastOrderTime }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="customer-remark">
                            <div class="bottom-item flex-col flex-around" v-for="(oItem, oIndex) in item.prodList" :key="oIndex">
                                <div class="bottom-item-name flex flex-start">
                                    <div class="Blacks font26">{{ oItem.prodName }}</div>
                                    <div class="give-tag" v-if="oItem.isSend">赠</div>
                                </div>
                                <div class="Greys font24">到期时间：{{ oItem.expiredTime }}</div>
                                <!-- <div class="Greys font24">余额：{{oItem.balance}}</div> -->
                            </div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
            <van-popup v-model="showEmployeePopup" round position="bottom" closeable class="popup" get-container="#app">
                <picker :title="employeePopupTitle" v-model="checkedEmployee" :list="employeeList" @change="onEmployeeChange">
                </picker>
            </van-popup>
            <van-popup v-model="showTypePopup" round position="bottom" closeable class="popup" get-container="#app">
                <picker title="选择类型" v-model="checkedType" :list="typeList" @change="onTypeChange"></picker>
            </van-popup>
            <!-- 区经区总 切换区域 -->
            <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
                <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
            </van-popup>
            <!-- 区经区总 切换门店 -->
            <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
                <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
            </van-popup>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Search, Toast } from "vant";
    import Picker from '@/components/Picker';
    import { getCookie } from '@/utils'
    import { openEnterpriseChat, navigateToAddCustomer } from '@/utils/wxCodeAuth'
    import { mapState } from 'vuex'
    import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'

    export default {
        name: "expireRemind",
        components: {
            [Search.name]: Search, Picker
        },
        inject: ['reload'],
        data() {
            return {
                isSend: false,
                showEmployeePopup: false,// 选择员工弹窗
                showTypePopup: false,// 选择类型弹窗
                searchStr: '',  // 搜索条件
                page: 1,       // 当前页
                limit: 10,       // 每页多少条
                total: 0,     // 列表总条数
                expireList: [],    // 列表
                loading: false,    // 加载
                finished: false,    // 结束加载
                refreshing: false,   // 刷新
                employeeList: [], // 员工
                checkedEmployee: null,//所选员工
                checkedType: { id: '0', name: '全部' },//所选类型
                postId: 0, // 岗位
                dateTime: "",
                showRegionPopup: false,
                showRegionStorePopup: false,
                regionStoreList: [],//区域门店列表
                regionList: [],//区域列表
                checkedRegion: { id: -1, name: '' },//所选区域
                checkedStore: {  //所选门店
                    name: '',
                    id: -1,
                },
                dimension: 0,
                employeePopupTitle: ''
            };
        },
        computed: {
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                },// 区经区总id
            }),
            typeList() { // 类型列表
                if (this.dimension == 1) {
                    return [
                        {
                            name: '全部',
                            id: "0"
                        },
                        {
                            name: '医美券院',
                            id: "1"
                        },
                        {
                            name: '生美券院',
                            id: "2"
                        },
                        {
                            name: '仅查看赠品',
                            id: "3"
                        },
                        {
                            name: '抗衰券院',
                            id: "4"
                        }
                    ]
                } else if (this.dimension == 2) {
                    return [
                        {
                            name: '全部',
                            id: "0"
                        },
                        {
                            name: '院余',
                            id: "1"
                        },
                        {
                            name: '券余',
                            id: "2"
                        },
                        {
                            name: '仅查看赠品',
                            id: "3"
                        }
                    ]
                }
            }
        },
        mounted() {
            this.dimension = JSON.parse(localStorage.getItem('employeeInfo')).dimension
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            this.employeePopupTitle = this.dimension == 1 ? '全部员工' : '主诊人' // 选择器标题

            this.init()
        },
        methods: {
            async init() {
                // 获取当前登陆人所记录的区域门店信息
                getUserLogin().then((res) => {
                    if (this.regionPostId.includes(this.postId)) {
                        this.checkedRegion.name = res.data.region?.storeName // 当前区域
                        this.checkedRegion.id = res.data.region?.id
                        if (res.data.store) {
                            this.checkedStore.name = res.data.store.storeName //当前门店
                            this.checkedStore.id = res.data.store.id
                            // 门店列表
                            let params = {
                                id: this.checkedRegion.id
                            }
                            getRegionStoreList(params).then((res) => {
                                this.regionStoreList = res.data
                            })
                        }
                        // 区域列表
                        getRegionStoreList().then((res) => {
                            this.regionList = res.data
                        })
                        // 如果当前没有选择门店记录，则进入大区页面
                        if (this.checkedStore.id == 0 || this.checkedStore.id == -1) {
                            this.$router.replace({
                                name: "expireRemindRegionPage"
                            });
                        }
                    }
                    this.getEmpList()
                    this.onLoad()
                })
            },
            onLoad() {
                this.loading = true
                let params = {
                    keysword: this.searchStr,
                    limit: this.limit,
                    page: this.page,
                    attendingId: this.checkedEmployee && this.checkedEmployee.id,
                    employeeId: this.checkedEmployee && this.checkedEmployee.id,
                    isSend: this.isSend,
                    isLiving: this.checkedType && this.checkedType.id,
                }
                if (this.regionPostId.includes(this.postId)) {
                    params.id = this.checkedRegion.id
                    params.storeId = this.checkedStore.id
                }
                request({
                    url: "/debt/getCustCouponStorageInfoList",
                    method: "get",
                    params: params
                })
                    .then((res) => {
                        this.dateTime = res.data.dateTime
                        this.expireList = this.page == 1 ? res.data.list : this.expireList.concat(res.data.list);
                        this.page += 1;
                        this.total = res.data.total;
                    }).catch((error) => {
                        this.finished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.loading = false;
                        this.refreshing = false;
                        if (this.expireList.length >= this.total) {
                            this.finished = true;
                        }
                    });
            },
            // 获取员工列表
            getEmpList() {
                const sendData = {
                    storeId: this.checkedStore.id,
                }
                return request({
                    url: this.dimension == 1 ? '/workEmployee/getEmployeeList' : "/sys/params/selectByStoreTreasure",
                    method: "get",
                    params: this.dimension == 1 ? '' : sendData
                })
                    .then((res) => {
                        this.employeeList = res.data
                        this.checkedEmployee = this.employeeList[0] //默认全部

                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            //搜索
            onSearch() {
                this.page = 1
                this.onLoad();
            },
            onRefresh() {
                this.page = 1
                // 清空列表数据
                this.finished = false;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.expireList = [];
                this.refreshing = false;
                this.onLoad();
            },
            //查看详情
            toDetail(custId, phone) {
                this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
            },
            //清除搜索
            selClear() {
                this.searchStr = "";
                this.onRefresh()
            },
            // 弹窗
            selectEmployeePopup() {
                this.showEmployeePopup = true
            },
            selectTypePopup() {
                this.showTypePopup = true
            },
            // 筛选相关
            onEmployeeChange(data) {
                this.checkedEmployee = data
                this.showEmployeePopup = false
                this.onRefresh()
            },
            onTypeChange(data) {
                this.checkedType = data;
                this.showTypePopup = false;
                this.onRefresh();
            },
            // 去打电话
            toContact(phone) {
                window.location.href = `tel:${phone}`;
            },
            //打开会话
            toOpenWechat(item) {
                if (item.isWxContact == true)   //是好友打开会话
                    openEnterpriseChat('', item.wxExternalUserid, '', '')
                else
                    //不是好友d，打开添加客户页面
                    navigateToAddCustomer('')
            },
            // 筛选区域门店相关
            openRegionPopup() {
                this.showRegionPopup = true
            },
            onRegionChange(data) {
                this.checkedRegion = data
                this.showRegionPopup = false
                this.$nextTick(() => {
                    // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                    this.checkedStore.id = 0
                    let params = {
                        id: this.checkedRegion.id,
                        storeId: this.checkedStore.id
                    }
                    saveRegionStore(params).then((res) => {
                        this.reload()
                    })
                })
            },
            openRegionStorePopup() {
                this.showRegionStorePopup = true
            },
            onRegionStoreChange(data) {
                this.checkedStore = data
                this.showRegionStorePopup = false
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then(() => {
                    if (data.id == 0 || data.id == -1) {
                        this.$router.replace({
                            name: "expireRemindRegionPage"
                        });
                    } else {
                        this.reload();
                    }
                })
            },
        },
    };
</script>

<style scoped lang="less">
    ::-webkit-scrollbar {
        display: none;
    }

    .mr-50 {
        margin-right: 50px;
    }

    .date-box {
        margin-top: 30px;
        margin-right: 30px;
        margin-left: 30px;
    }

    .van-pull-refresh {
        min-height: 100%;
    }

    .list-box {
        width: 100%;
        height: calc(100vh - 245px);
        justify-content: space-between;
        margin: 0 auto 0;
        position: relative;
        z-index: 1;
        overflow-y: auto;
        padding: 0 30px 30px 30px;
        margin-top: 10px;
    }

    .customer-list {
        width: 690px;
        background: #fafafe;
        border-radius: 20px;
        margin-bottom: 20px;
        padding: 30px 0;
    }

    .top-box {
        padding: 0 20px 20px 20px;
    }

    .customer-name {
        min-width: 60px;
        font-size: 30px;
        color: #35434c;
        font-weight: 700;
    }

    .churn-time {
        height: 37px;
        font-size: 26px;
        color: #66757f;
        line-height: 37px;
        margin-top: 14px;
    }

    .store-time {
        margin-top: 4px;
    }

    .nursing-edit-box {
        margin: 37px 0 0 163px;
    }

    .card-icon {
        width: 90px;
        height: 34px;
        margin-left: 10px;
    }

    .arrow_right {
        width: 15px;
        height: 26px;
        margin-left: 20px;
    }

    .icon-item {
        width: 46px;
        height: 46px;
    }

    .chat-icon {
        margin-right: 40px;
    }

    .cake-icon {
        width: 28px;
        height: 26px;
        margin-right: 11px;
    }

    .card-image {
        height: 34px;
        width: 90px;
        margin: 24px 0 0 10px;
    }

    .customerHeadPortrait {
        width: 90px;
        height: 90px;
        border-radius: 45px;
        margin-right: 20px;
    }

    .customer-remark {
        border-top: 1px solid #d7d7d7;
        padding: 10px 20px 0 20px;
        overflow: hidden;
    }

    .bottom-item {
        width: 650px;
        min-height: 113px;
        background: #ffffff;
        border-radius: 6px;
        margin-top: 10px;
        border: 1px solid #e8e8ea;
        padding: 16px 20px;
    }

    .bottom-item-name {
        margin-bottom: 11px;

        .give-tag {
            width: 32px;
            height: 32px;
            background: #f65252;
            border-radius: 8px;
            color: #fff;
            font-size: 20px;
            text-align: center;
            line-height: 32px;
            margin-left: 43px;
        }
    }

    .sale-number {
        height: 45px;
        font-size: 28px;
        color: #35434c;
        line-height: 45px;
        margin-top: 28px;
        min-width: 40px;
        font-weight: 700;
    }

    .select-box {
        margin-left: 30px;
        margin-top: 10px;
        margin-bottom: 20px;

        .select-tit {
            font-size: 28px;
            color: #35434c;
        }

        .select-arrow {
            transform: rotate(90deg);
            font-size: 24px;
            margin-left: 10px;
        }
    }

    .store-box {
        padding: 30px 30px 0 30px;
        background-color: #fff;

        .store-arrow {
            width: 16px;
            height: 26px;
            margin-left: 8px;
            margin-top: 3px;
        }

        .region-name-box {
            min-width: 239px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            margin-right: 10px;
            padding: 10px 15px 11px 16px;
        }

        .store-name-box {
            min-width: 187px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            padding: 10px 15px 11px 16px;
        }

        .name-txt {
            color: #66757f;
            font-size: 26px;
        }
    }

    :deep(.van-checkbox__icon) {
        width: 32px;
        height: 32px;
    }

    :deep(.van-checkbox__icon .van-icon) {
        width: 32px;
        height: 32px;
        line-height: 32px;
    }

    :deep(.van-search) {
        padding: 19px 30px 19px 30px;
    }

    :deep(.search-button .van-field__left-icon) {
        color: #c8c9cc !important;
        padding: 3px 20px 0 0 !important;
        margin-right: 0 !important;
    }

    :deep(.van-icon__image) {
        height: 28px;
        display: inline-block;
    }

    :deep(.van-field__control) {
        font-size: 28px !important;
    }

    :deep(.van-radio__label) {
        color: #a0acb5;
    }
</style>
